// extracted by mini-css-extract-plugin
export var readonly = "_dm-1";
export var star = "_dm-0";